export default __webpack_public_path__ + "static/media/gully_03.3a11c21b.png";